/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_FormattingInputs */



/**
* | output |
* | --- |
* | "Clear Formatting" |
*
* @param {Clear_FormattingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clear_formatting = /** @type {((inputs?: Clear_FormattingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_FormattingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer la mise en forme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formatierung löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella formattazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить форматирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清晰格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書式をクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पष्ट स्वरूपण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação clara")
	return /** @type {LocalizedString} */ ("Clear Formatting")
});